/* Zêrîn theme script: hero motion, collection filters, personalisation, product preview. */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

  function toast(msg) {
    var t = $("#toast"); if (!t) return;
    t.textContent = msg; t.classList.add("show");
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.classList.remove("show"); }, 2600);
  }

  /* ---------- fix decomposed accents (û, î, ê) from product data ---------- */
  (function nfc(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) { var v = n.nodeValue; if (/[\u0300-\u036f]/.test(v)) n.nodeValue = v.normalize("NFC"); }
  })(document.body);

  /* ---------- logo sun ---------- */
  var logo = $("#logoSun");
  if (logo) {
    var lc = logo.getContext("2d");
    var drawLogo = function (t) {
      var c = 30, R = 12; lc.clearRect(0, 0, 60, 60); lc.save(); lc.translate(c, c); lc.rotate(t * 0.0004);
      for (var i = 0; i < 12; i++) { lc.rotate(Math.PI / 6); lc.fillStyle = "#c99a45"; lc.beginPath(); lc.moveTo(R * 0.9, -2.2); lc.lineTo(i % 2 ? R * 1.9 : R * 2.4, 0); lc.lineTo(R * 0.9, 2.2); lc.fill(); }
      lc.restore(); var g = lc.createRadialGradient(c - 4, c - 4, 1, c, c, R); g.addColorStop(0, "#f6dc9a"); g.addColorStop(1, "#a67b2c");
      lc.fillStyle = g; lc.beginPath(); lc.arc(c, c, R * 0.8, 0, 7); lc.fill();
      if (!reduce) requestAnimationFrame(drawLogo);
    };
    requestAnimationFrame(drawLogo);
  }

  /* ---------- gold dust ---------- */
  var dust = $("#dust");
  if (dust && !reduce) for (var di = 0; di < 22; di++) { var m = document.createElement("i"); m.style.left = (8 + Math.random() * 55) + "%"; m.style.top = (15 + Math.random() * 70) + "%"; var z = 0.6 + Math.random() * 1.6; m.style.width = m.style.height = z * 2 + "px"; m.style.animationDuration = (9 + Math.random() * 10) + "s"; m.style.animationDelay = (-Math.random() * 15) + "s"; dust.appendChild(m); }

  /* ---------- header ---------- */
  var bar = $("#topbar");
  if (bar && $("#hero")) {
    var onScroll = function () { bar.classList.toggle("solid", scrollY > 24); };
    addEventListener("scroll", onScroll, { passive: true }); onScroll();
  }

  /* ---------- hero ---------- */
  var mega = $("#mega");
  if (mega) {
    var word = mega.textContent.trim();
    mega.innerHTML = Array.from(word).map(function (ch, i) {
      return '<span class="ch" aria-hidden="true"><span style="animation-delay:' + (0.15 + i * 0.08) + 's">' + ch + "</span></span>";
    }).join("");
  }


  /* ---------- collection grid ---------- */
  var grid = $("#pgrid");
  if (grid && $("#themes")) {
    var st = { theme: "alle", q: "", sort: "rec" };
    var cards = $$(".pcard", grid);
    cards.forEach(function (c, i) { c.dataset.rec = i; });
    var norm = function (t) { return (t || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, ""); };
    var SYN = { tee: "cay", pfau: "tawus", engel: "tawus", tanz: "govend", hochzeit: "dilan", feuer: "newroz", laute: "tembur", musik: "tembur", familie: "mala", zuhause: "mala", granatapfel: "mala", mutter: "mutter", kind: "kind" };
    var apply = function () {
      var first = new Map(cards.map(function (c) { return [c, c.getBoundingClientRect()]; }));
      var q = norm(st.q.trim()), shown = 0;
      cards.forEach(function (c) {
        var hay = norm(c.dataset.name + " " + c.dataset.tags + " " + c.getAttribute("href"));
        var syn = Object.keys(SYN).some(function (k) { return q && k.indexOf(q) === 0 && hay.indexOf(SYN[k]) > -1; });
        var hit = (st.theme === "alle" || (" " + c.dataset.tags + " ").indexOf(" " + st.theme + " ") > -1) && (!q || hay.indexOf(q) > -1 || syn);
        c.hidden = !hit; if (hit) shown++;
      });
      var sorted = cards.slice().sort(function (a, b) {
        if (st.sort === "az") return a.dataset.name.localeCompare(b.dataset.name, "de");
        if (st.sort === "price") return (+a.dataset.price) - (+b.dataset.price);
        return (+a.dataset.rec) - (+b.dataset.rec);
      });
      sorted.forEach(function (c, i) { c.style.order = i; });
      var cnt = $("#count"); if (cnt) cnt.textContent = shown === 1 ? "1 Motiv" : shown + " Motive";
      var nr = $("#noresult"); if (nr) nr.hidden = shown > 0;
      if (reduce) return;
      cards.forEach(function (c) {
        if (c.hidden) return; var a = first.get(c), b = c.getBoundingClientRect();
        if (a.width === 0) { c.animate([{ opacity: 0, transform: "translateY(20px)" }, { opacity: 1, transform: "none" }], { duration: 500, easing: "cubic-bezier(.2,.7,.1,1)" }); return; }
        var dx = a.left - b.left, dy = a.top - b.top;
        if (dx || dy) c.animate([{ transform: "translate(" + dx + "px," + dy + "px)" }, { transform: "none" }], { duration: 600, easing: "cubic-bezier(.2,.7,.1,1)" });
      });
    };
    $("#themes").addEventListener("click", function (e) {
      var b = e.target.closest("button"); if (!b) return; st.theme = b.dataset.k;
      $$("#themes button").forEach(function (x) { x.setAttribute("aria-pressed", x === b); }); apply();
    });
    var q = $("#q"); if (q) q.addEventListener("input", function () { st.q = q.value; apply(); });
    var so = $("#sort"); if (so) so.addEventListener("change", function () { st.sort = so.value; apply(); });
    var rs = $("#resetF"); if (rs) rs.addEventListener("click", function () {
      st.theme = "alle"; st.q = ""; if (q) q.value = ""; $$("#themes button").forEach(function (x, i) { x.setAttribute("aria-pressed", i === 0); }); apply();
    });
    var fp = $("#framePick"); if (fp) fp.addEventListener("click", function (e) {
      var b = e.target.closest("button"); if (!b) return;
      $$("button", fp).forEach(function (x) { x.setAttribute("aria-pressed", x === b); });
      $$(".pcard .framed", grid).forEach(function (f, i) { setTimeout(function () { f.dataset.f = b.dataset.k; }, i * 45); });
    });
  }

  /* ---------- personalisation: name printed into the poster ---------- */
  var setPz = function (root, v) {
    v = (v || "").trim();
    $$(".pz", root).forEach(function (pz) {
      var n = $(".pz-n", pz); if (!n) return;
      var changed = n.textContent !== v;
      n.textContent = v;
      pz.classList.toggle("has-name", !!v);
      pz.style.setProperty("--fit", Math.min(1, 15 / Math.max(15, v.length)).toFixed(3));
      if (v && changed && !reduce && n.animate) n.animate([{ opacity: 0.3, transform: "translateY(4px)" }, { opacity: 1, transform: "none" }], { duration: 380, easing: "cubic-bezier(.2,.7,.1,1)" });
    });
  };

  /* ---------- personalisation studio (home) ---------- */
  var pIn = $("#persoInput");
  if (pIn) {
    var studio = $("#persoFrame"), go = $("#persoGo");
    var setName = function (v) {
      pIn.value = v; setPz(studio, v);
      if (go) go.href = go.dataset.base + (v.trim() ? "?name=" + encodeURIComponent(v.trim()) : "");
    };
    pIn.addEventListener("input", function () { setName(pIn.value); });
    pIn.addEventListener("focus", function () {
      if (innerWidth > 900) return;
      setTimeout(function () { var y = pIn.getBoundingClientRect().top + scrollY - 120; scrollTo({ top: y, behavior: reduce ? "auto" : "smooth" }); }, 250);
    });
    var ex = $("#examples"); if (ex) ex.addEventListener("click", function (e) { var b = e.target.closest("button"); if (b) setName(b.textContent); });
    var pf = $("#p2Frames"); if (pf) pf.addEventListener("click", function (e) {
      var b = e.target.closest("button"); if (!b) return;
      $$("button", pf).forEach(function (x) { x.setAttribute("aria-pressed", x === b); });
      if (studio) studio.dataset.f = b.dataset.k;
    });
    setName(pIn.value);
  }

  /* ---------- product page ---------- */
  var stage = $("#stage");
  if (stage) {
    var ps = { view: "nah", frame: "ohne" };
    var perso = $("#pPerso");
    var params = new URLSearchParams(location.search);
    if (perso && params.get("name")) perso.value = params.get("name");
    var esc = function (s) { var d = document.createElement("div"); d.textContent = s; return d.innerHTML; };
    var tplArt = $("#pzArt"), tplRoom = $("#pzRoom");
    var pzHTML = function (t) { return t ? t.innerHTML : ""; };
    var curName = function () { return perso ? perso.value : ""; };
    var eur = function (c) { return (c / 100).toLocaleString("de-DE", { style: "currency", currency: "EUR" }); };
    var frames = []; try { frames = JSON.parse(($("#frameData") || {}).textContent || "[]"); } catch (e) {}
    var sel = function () { return $("#sizes [aria-selected='true']"); };
    var frameVariant = function (k) {
      var s = sel(); if (!s || k === "ohne") return null;
      for (var i = 0; i < frames.length; i++) if (frames[i].k === k && frames[i].s === s.dataset.title) return frames[i];
      return null;
    };
    var widthCm = function () {
      var t = (sel() || { dataset: {} }).dataset.title || "";
      var m = t.replace(/,/g, ".").match(/(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)/);
      return m ? parseFloat(m[1]) : 30;
    };
    var framed = function () {
      return '<div class="framed" data-f="' + ps.frame + '"><div class="mat"><div class="art pzwrap"><img src="' + stage.dataset.art + '" alt="' + esc(stage.dataset.title) + '">' + pzHTML(tplArt) + '<div class="glass"></div></div></div></div>';
    };
    var render = function () {
      if (ps.view === "nah") stage.innerHTML = '<div class="closeup">' + framed() + "</div>";
      else if (ps.view === "wand") {
        /* wall photo: sideboard is 160 cm wide and spans --sb of the image width */
        var sb = parseFloat(getComputedStyle(stage).getPropertyValue("--sb")) || 46;
        var pw = widthCm() + (ps.frame !== "ohne" ? 4 : 0);
        stage.innerHTML = '<div class="wall"><div class="insitu" style="width:' + Math.min(64, pw / 160 * sb).toFixed(2) + '%">' + framed() + '</div><div class="ruler">Sideboard 160 cm · Motiv ' + esc(($("#sizeLabel") || {}).textContent || "") + "</div></div>";
      } else if (ps.view === "raum" && stage.dataset.room) stage.innerHTML = '<div class="roomwrap"><div class="pzwrap"><img class="roomimg" src="' + stage.dataset.room + '" alt="' + esc(stage.dataset.title) + ' im Raum">' + pzHTML(tplRoom) + "</div></div>";
      setPz(stage, curName());
      if (!reduce && stage.firstElementChild) stage.firstElementChild.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 400 });
    };
    var updatePrice = function () {
      var s = sel(); if (!s) return;
      var base = parseInt(s.dataset.cents, 10), fv = frameVariant(ps.frame);
      var pr = $("#pPrice"); pr.textContent = eur(base + (fv ? fv.c : 0));
      if (!reduce) pr.animate([{ transform: "translateY(-6px)", opacity: 0.5 }, { transform: "none", opacity: 1 }], { duration: 400 });
      $$("#frames .fp").forEach(function (em) {
        var k = em.dataset.fp;
        if (k === "ohne") { em.textContent = ""; return; }
        var v = frameVariant(k); em.textContent = v ? "+ " + eur(v.c) : "";
        if (frames.length) em.closest(".chip").toggleAttribute("data-na", !v || !v.a);
      });
      var fl = $("#frameLabel"), cur = frameVariant(ps.frame);
      if (fl) fl.textContent = ps.frame === "ohne" ? "Ohne Rahmen" : (ps.frame.charAt(0).toUpperCase() + ps.frame.slice(1)) + (cur ? " · + " + eur(cur.c) : "");
    };
    $("#viewTabs").addEventListener("click", function (e) {
      var b = e.target.closest("button"); if (!b) return; ps.view = b.dataset.k;
      $$("#viewTabs button").forEach(function (x) { x.setAttribute("aria-pressed", x === b); }); render();
    });
    var dd = $("#sizeDD"), ddBtn = $("#ddBtn"), list = $("#sizes");
    var openDD = function (on) { list.hidden = !on; ddBtn.setAttribute("aria-expanded", on); dd.classList.toggle("open", on); if (on) { var s = $("[aria-selected='true']", list); if (s) s.focus(); } };
    var pick = function (li) {
      if (!li || li.getAttribute("aria-disabled") === "true") return;
      $$("li", list).forEach(function (x) { x.setAttribute("aria-selected", x === li); });
      $("#variantId").value = li.dataset.id; $("#sizeLabel").textContent = li.dataset.title;
      var u = new URL(location.href); u.searchParams.set("variant", li.dataset.id); history.replaceState(null, "", u);
      openDD(false); ddBtn.focus();
      updatePrice();
      if (ps.view === "wand") render();
    };
    ddBtn.addEventListener("click", function () { openDD(list.hidden); });
    list.addEventListener("click", function (e) { pick(e.target.closest("li")); });
    list.addEventListener("keydown", function (e) {
      var items = $$("li", list), i = items.indexOf(document.activeElement);
      if (e.key === "ArrowDown") { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
      else if (e.key === "ArrowUp") { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
      else if (e.key === "Enter" || e.key === " ") { e.preventDefault(); pick(document.activeElement); }
      else if (e.key === "Escape") { openDD(false); ddBtn.focus(); }
    });
    document.addEventListener("click", function (e) { if (!dd.contains(e.target)) openDD(false); });
    var jump = $("[data-room-jump]"); if (jump) jump.addEventListener("click", function (e) { var r = $("#raum"); if (r) { e.preventDefault(); scrollTo({ top: r.getBoundingClientRect().top + scrollY - 90, behavior: reduce ? "auto" : "smooth" }); } });
    $("#frames").addEventListener("click", function (e) {
      var b = e.target.closest(".chip"); if (!b || b.hasAttribute("data-na")) return; ps.frame = b.dataset.k;
      $$("#frames .chip").forEach(function (x) { x.setAttribute("aria-pressed", x === b); });
      if (ps.view === "raum") { ps.view = "nah"; $$("#viewTabs button").forEach(function (x) { x.setAttribute("aria-pressed", x.dataset.k === "nah"); }); }
      var f = $(".framed", stage);
      if (f && ps.view === "nah") f.dataset.f = ps.frame; else render();
      updatePrice();
    });
    if (perso) perso.addEventListener("input", function () { setPz(document, perso.value); });
    render(); updatePrice(); setPz(document, curName());

    /* ---------- live camera preview ---------- */
    var ar = $("#ar"), arOpen = $("#arOpen");
    if (ar && arOpen) {
      document.body.appendChild(ar);
      var arV = $("#arVideo"), arP = $("#arPoster"), arPh = $("#arPhoto"), arMsg = $("#arMsg"), arSize = $("#arSize"), stream = null;
      var pos = { x: 50, y: 42, w: 40 };
      var place = function () { arP.style.left = pos.x + "%"; arP.style.top = pos.y + "%"; arP.style.width = pos.w + "%"; arSize.value = pos.w; };
      var paint = function () {
        arP.innerHTML = framed(); setPz(arP, curName());
        $$("#arFrames button").forEach(function (b) { b.setAttribute("aria-pressed", b.dataset.k === ps.frame); });
      };
      var stop = function () { if (stream) { stream.getTracks().forEach(function (t) { t.stop(); }); stream = null; } };
      var showMsg = function (t) { $("#arMsgText").textContent = t; arMsg.hidden = false; };
      var usePhoto = function (f) {
        if (!f) return; stop(); arV.hidden = true; arMsg.hidden = true;
        arPh.src = URL.createObjectURL(f); arPh.hidden = false;
      };
      var openAR = function () {
        paint(); place(); ar.hidden = false; document.documentElement.style.overflow = "hidden";
        arMsg.hidden = true; arPh.hidden = true; arV.hidden = false;
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { arV.hidden = true; showMsg("Dein Browser erlaubt hier keine Kamera. Wähl einfach ein Foto deiner Wand."); return; }
        navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: "environment" }, width: { ideal: 1920 }, height: { ideal: 1080 } }, audio: false })
          .then(function (s) { stream = s; arV.srcObject = s; return arV.play(); })
          .catch(function () { arV.hidden = true; showMsg("Wir konnten die Kamera nicht öffnen. Erlaube den Kamerazugriff oder wähl ein Foto deiner Wand."); });
      };
      var closeAR = function () { stop(); ar.hidden = true; document.documentElement.style.overflow = ""; };
      arOpen.addEventListener("click", openAR);
      $("#arClose").addEventListener("click", closeAR);
      addEventListener("keydown", function (e) { if (e.key === "Escape" && !ar.hidden) closeAR(); });
      ["#arFile", "#arFile2"].forEach(function (id) { var i = $(id); if (i) i.addEventListener("change", function () { usePhoto(i.files[0]); }); });
      arSize.addEventListener("input", function () { pos.w = +arSize.value; place(); });
      $("#arFrames").addEventListener("click", function (e) {
        var b = e.target.closest("button"); if (!b) return;
        var chip = $('#frames .chip[data-k="' + b.dataset.k + '"]');
        if (chip && !chip.hasAttribute("data-na")) chip.click(); else { ps.frame = b.dataset.k; }
        paint();
      });
      /* drag + pinch */
      var pts = new Map(), start = null;
      var snap = function () {
        var a = Array.from(pts.values()), r = ar.getBoundingClientRect();
        var cx = a.reduce(function (s, p) { return s + p.x; }, 0) / a.length, cy = a.reduce(function (s, p) { return s + p.y; }, 0) / a.length;
        var d = a.length > 1 ? Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y) : 0;
        return { cx: cx / r.width * 100, cy: cy / r.height * 100, d: d, x: pos.x, y: pos.y, w: pos.w };
      };
      arP.addEventListener("pointerdown", function (e) { arP.setPointerCapture(e.pointerId); pts.set(e.pointerId, { x: e.clientX, y: e.clientY }); start = snap(); });
      ar.addEventListener("pointerdown", function (e) { if (e.target === arP || arP.contains(e.target)) return; if (pts.size === 1) { pts.set(e.pointerId, { x: e.clientX, y: e.clientY }); start = snap(); } });
      ar.addEventListener("pointermove", function (e) {
        if (!pts.has(e.pointerId)) return; pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        var now = snap();
        pos.x = Math.max(5, Math.min(95, start.x + now.cx - start.cx));
        pos.y = Math.max(8, Math.min(88, start.y + now.cy - start.cy));
        if (pts.size > 1 && start.d) pos.w = Math.max(12, Math.min(90, start.w * now.d / start.d));
        place();
      });
      var up = function (e) { pts.delete(e.pointerId); start = pts.size ? snap() : null; };
      ar.addEventListener("pointerup", up); ar.addEventListener("pointercancel", up);

      /* shutter: wall + poster as one photo */
      var FRAME = { eiche: "#b4834f", schwarz: "#151515", gold: "#c9a24f" };
      var loadImg = function (src) { return new Promise(function (res, rej) { var im = new Image(); im.crossOrigin = "anonymous"; im.onload = function () { res(im); }; im.onerror = rej; im.src = src; }); };
      var drawCover = function (ctx, src, sw, sh, W, H) { var s = Math.max(W / sw, H / sh), dw = sw * s, dh = sh * s; ctx.drawImage(src, (W - dw) / 2, (H - dh) / 2, dw, dh); };
      var shot = $("#arShot");
      if (shot) shot.addEventListener("click", function () {
        var R = ar.getBoundingClientRect(), k = Math.min(3, Math.max(2, (window.devicePixelRatio || 1))), W = Math.round(R.width * k), H = Math.round(R.height * k);
        var cv = document.createElement("canvas"); cv.width = W; cv.height = H; var ctx = cv.getContext("2d");
        ctx.fillStyle = "#e8dccb"; ctx.fillRect(0, 0, W, H);
        if (!arV.hidden && arV.videoWidth) drawCover(ctx, arV, arV.videoWidth, arV.videoHeight, W, H);
        else if (!arPh.hidden && arPh.naturalWidth) drawCover(ctx, arPh, arPh.naturalWidth, arPh.naturalHeight, W, H);
        var fr = $(".framed", arP), artEl = $(".art", arP), img = $(".art img", arP);
        if (!fr || !img) return;
        shot.disabled = true;
        var rel = function (el) { var r = el.getBoundingClientRect(); return { x: (r.left - R.left) * k, y: (r.top - R.top) * k, w: r.width * k, h: r.height * k }; };
        var F = rel(fr), A = rel(artEl);
        loadImg(img.currentSrc || img.src).then(function (im) {
          ctx.save(); ctx.shadowColor = "rgba(0,0,0,.45)"; ctx.shadowBlur = 26 * k; ctx.shadowOffsetY = 14 * k;
          ctx.fillStyle = FRAME[ps.frame] || "#000"; ctx.fillRect(F.x, F.y, F.w, F.h); ctx.restore();
          if (FRAME[ps.frame]) { var g = ctx.createLinearGradient(F.x, F.y, F.x + F.w, F.y + F.h); g.addColorStop(0, "rgba(255,255,255,.22)"); g.addColorStop(.5, "rgba(255,255,255,0)"); g.addColorStop(1, "rgba(0,0,0,.18)"); ctx.fillStyle = g; ctx.fillRect(F.x, F.y, F.w, F.h); }
          ctx.drawImage(im, A.x, A.y, A.w, A.h);
          $$(".pz-t, .pz-n", arP).forEach(function (sp) {
            if (!sp.textContent.trim() || getComputedStyle(sp).opacity === "0") return;
            var cs = getComputedStyle(sp), r = rel(sp);
            ctx.font = cs.fontStyle + " " + cs.fontWeight + " " + parseFloat(cs.fontSize) * k + "px " + cs.fontFamily;
            if ("letterSpacing" in ctx) ctx.letterSpacing = (parseFloat(cs.letterSpacing) || 0) * k + "px";
            ctx.textAlign = "center"; ctx.textBaseline = "middle";
            ctx.fillStyle = sp.classList.contains("pz-n") ? (sp.closest(".pz-ink") ? "#5a2a1e" : "#efcf86") : cs.color;
            var lsx = sp.classList.contains("pz-t") ? (parseFloat(cs.letterSpacing) || 0) * k / 2 : 0;
            ctx.fillText(sp.textContent, r.x + r.w / 2 + lsx, r.y + r.h / 2);
          });
          ctx.font = 500 * 1 + " " + 13 * k + "px " + getComputedStyle(document.body).fontFamily; ctx.fillStyle = "rgba(255,255,255,.85)"; ctx.textAlign = "right"; ctx.textBaseline = "alphabetic"; if ("letterSpacing" in ctx) ctx.letterSpacing = "0px";
          ctx.shadowColor = "rgba(0,0,0,.5)"; ctx.shadowBlur = 6 * k; ctx.fillText("zeringallery.com", W - 16 * k, H - 16 * k);
          var fl = $("#arFlash"); fl.classList.remove("go"); void fl.offsetWidth; fl.classList.add("go");
          cv.toBlob(function (blob) {
            var fname = "zerin-" + (stage.dataset.title || "poster").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-") + ".jpg";
            var file = new File([blob], fname, { type: "image/jpeg" });
            if (navigator.canShare && navigator.canShare({ files: [file] })) {
              navigator.share({ files: [file], title: stage.dataset.title + " bei mir an der Wand" }).catch(function () {});
            } else {
              var a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = fname; document.body.appendChild(a); a.click(); a.remove();
              setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
            }
            toast("Foto gespeichert");
            shot.disabled = false;
          }, "image/jpeg", 0.9);
        }).catch(function () { shot.disabled = false; toast("Foto konnte nicht erstellt werden"); });
      });
      ar.addEventListener("wheel", function (e) { e.preventDefault(); pos.w = Math.max(12, Math.min(90, pos.w - e.deltaY * 0.03)); place(); }, { passive: false });
    }

    var form = $("#pForm");
    if (form && window.fetch) form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = $("#addBtn"); btn.disabled = true;
      var name = perso ? perso.value.trim() : "";
      var item = { id: parseInt($("#variantId").value, 10), quantity: 1 };
      if (name) item.properties = { Name: name };
      var items = [item], fv = frameVariant(ps.frame);
      if (fv) items.push({ id: fv.id, quantity: 1, properties: { "Für": stage.dataset.title + " · " + ((sel() || { dataset: {} }).dataset.title || "") } });
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart/add.js", { method: "POST", body: JSON.stringify({ items: items }), headers: { "Content-Type": "application/json", Accept: "application/json" } })
        .then(function (r) { if (!r.ok) throw r; return fetch("/cart.js"); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = $("#cartN"); if (n) { n.textContent = cart.item_count; n.parentElement.classList.add("bump"); setTimeout(function () { n.parentElement.classList.remove("bump"); }, 400); }
          toast(stage.dataset.title + (fv ? " mit Rahmen" : "") + " liegt im Warenkorb");
        })
        .catch(function () { form.submit(); })
        .finally(function () { btn.disabled = false; });
    });
  }
})();
